import { Button, Typography } from '@mui/material';
import { func, number } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { I18n } from 'utils/i18n';

const SendToAllButton = ({ onSend, total }) => {
  const [isSend, setIsSend] = useState(false);
  const timerRef = useRef(null);

  useEffect(
    () => () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    },
    [],
  );

  const handleSend = () => {
    setIsSend(true);
    timerRef.current = setTimeout(() => setIsSend(false), 30000);
    onSend();
  };

  if (isSend) {
    return (
      <Typography
        sx={{
          padding: '0 15px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {I18n.t('AnalyticsDrawer.Reminders are sent!')}
      </Typography>
    );
  }

  return (
    <Button color="secondary" variant="outlined" onClick={handleSend} sx={{ ml: '15px' }}>
      {I18n.t('AnalyticsDrawer.Send again to %{count} pending', { count: total })}
    </Button>
  );
};

SendToAllButton.propTypes = {
  onSend: func.isRequired,
  total: number.isRequired,
};

export default SendToAllButton;
